import { defineComponent as _defineComponent } from 'vue'
import { useTask } from '@/ui/concerns';
  import { remove } from '@/services/api/resources/optionSet/actions';
  import { Modal } from '@/ui/components/Modal';
  import { PageSubtitle, ApiErrorMessage } from '@/ui/components';
  import { Button } from '@/ui/components/Button';
  import { CONFIRM_QUIT_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownResponseSetDeleteDialog',
  props: {
    active: {
      type: Boolean,
    },
    optionSetId: {
      type: Number,
    },
    propertyId: {
      type: Number,
    },
  },
  emits: ['close', 'deleted'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const deleteTask = useTask(
    () => {
      if (!props.optionSetId) {
        throw new Error('No option set ID provided');
      }
      return remove(props.optionSetId, props.propertyId);
    },
    () => {
      emit('deleted');
      emit('close');
    },
    undefined,
    () => {
      toasted.error(t('option-set.in-use-error'));
    },
  );

  const handleDelete = () => {
    if (props.optionSetId && props.optionSetId > 0) {
      deleteTask.run();
    }
  };

return { __sfc: true,props, emit, deleteTask, handleDelete, Modal, PageSubtitle, ApiErrorMessage, Button, CONFIRM_QUIT_MODAL_WIDTH }
}

})